import React from 'react';
export function Logo({
  className = '',
  height = 32
}: {
  className?: string;
  height?: number;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/6RR4RNWo3TE4wuyQXGNM2m/RIA_Catalyst_Logo_Blue.png" alt="RIA Catalyst" style={{
    height
  }} className={`w-auto ${className}`} data-id="element-27" />;
}